var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51489 4.57533C8.51489 5.09693 8.93773 5.51978 9.45934 5.51978H12.9245C13.4461 5.51978 13.8689 5.94262 13.8689 6.46422V7.60512C13.8689 8.12672 13.4461 8.54956 12.9245 8.54956H9.45934C8.93773 8.54956 8.51489 8.9724 8.51489 9.49401V12.9315C8.51489 13.4531 8.09205 13.8759 7.57045 13.8759H6.42955C5.90795 13.8759 5.48511 13.4531 5.48511 12.9315V9.494C5.48511 8.9724 5.06226 8.54956 4.54066 8.54956H1.07555C0.553946 8.54956 0.131104 8.12672 0.131104 7.60512V6.46422C0.131104 5.94262 0.553946 5.51978 1.07555 5.51978H4.54066C5.06226 5.51978 5.48511 5.09693 5.48511 4.57533V1.06871C5.48511 0.54711 5.90795 0.124268 6.42955 0.124268H7.57045C8.09205 0.124268 8.51489 0.54711 8.51489 1.06871V4.57533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.15d55fc92f74fb839a78264a6a0be88b.svg";
export { ForwardRef as ReactComponent };